import { ReactNode } from 'react'

import { AppDivider, AppParagraph } from 'client/ui-building-blocks'
import { Size } from '../types'

import styles from './app-message-box.module.scss'

type AppMessageBoxProps = {
  headerNode?: ReactNode
  paragraphs?: string[]
  buttonNode?: ReactNode
  size?: Size
}

const AppMessageBox = (props: AppMessageBoxProps) => {
  const { headerNode = null, paragraphs = [], buttonNode = null, size = 'medium' } = props

  return (
    <div className={styles.appMessageBox}>
      {headerNode && (
        <>
          {headerNode}
          {paragraphs.length > 0 ? <AppDivider size="xsmall" /> : null}
        </>
      )}
      {paragraphs.map((p, i) => (
        <div key={i}>
          <AppParagraph
            text={p}
            size={size}
            marginBottom={i < paragraphs.length - 1 ? 'xxsmall' : false}
          />
        </div>
      ))}
      {buttonNode && (
        <div>
          <AppDivider size="small" />
          {buttonNode}
        </div>
      )}
    </div>
  )
}

export default AppMessageBox
